export default __webpack_public_path__ + "static/media/hht1_direction_timeline_02.c8d5ab5c.jpg";